import Box from '@mui/material/Box';
import { Form } from 'react-admin';
import { Typography } from '@mui/material';
import CheckboxToShowBox from '@/components/common/forms/common/checkbox-to-show-box/checkbox-to-show-box';
import TextInputWithLabels from '@/components/common/forms/common/text-input-with-labels/text-input-with-labels';
import ImageInputWithLabelOnTop from '@/components/common/forms/common/image-input-with-label-on-top/image-input-with-label-on-top';

const formId = '_form_maintenance_curative_impact_d_allage_1';

interface Props {
    readOnly?: boolean;
    defaultValues?: (formId: string) => {};
}

const PavingImpactForm = ({ readOnly = false, defaultValues = (_formId: string): any => {} }: Props) => (
    <Form defaultValues={defaultValues(formId)}>
        <Box
            sx={{
                display: 'grid',
                gap: 2,
            }}
        >
            <Typography>Cochez la(es) case(s) pour saisir les valeurs</Typography>

            <CheckboxToShowBox
                label={'Trous : de 50 à 200 mm'}
                keysToRemoveFromFormValues={['TrousU50_200']}
                readOnly={readOnly}
            >
                <TextInputWithLabels rightLabel={'U'} source='TrousU50_200' readOnly={readOnly} />
            </CheckboxToShowBox>

            <CheckboxToShowBox label={'Eclat'} keysToRemoveFromFormValues={['EclatU']} readOnly={readOnly}>
                <TextInputWithLabels rightLabel={'U'} source='EclatU' readOnly={readOnly} />
            </CheckboxToShowBox>

            <CheckboxToShowBox label={'Angle de dallage'} keysToRemoveFromFormValues={['AngleU']} readOnly={readOnly}>
                <TextInputWithLabels rightLabel={'U'} source='AngleU' readOnly={readOnly} />
            </CheckboxToShowBox>

            <CheckboxToShowBox
                label={'Autre'}
                keysToRemoveFromFormValues={['AutreImpactDAllageTxt', 'AutreImpactDAllageU']}
                readOnly={readOnly}
            >
                <TextInputWithLabels
                    topLabel={'Description du besoin:'}
                    source='AutreImpactDAllageTxt'
                    multiline
                    readOnly={readOnly}
                />
                <TextInputWithLabels rightLabel={'U'} source='AutreImpactDAllageU' readOnly={readOnly} />
            </CheckboxToShowBox>

            <ImageInputWithLabelOnTop label='Joindre des photos (.png, .jpg)' source='media' readOnly={readOnly} />

            <TextInputWithLabels topLabel={'Précision sur la localisation'} source='Localisation' readOnly={readOnly} />
        </Box>
    </Form>
);

export default PavingImpactForm;
